import axiosInstance from '../../../../../services/axios/axios';
import { then } from '../../../../../services/axios/_utility';

/**
 * Performs existence check against email @param email.
 *
 * @function
 * @param {string} email email of interest to perform existence check against.
 * @returns {Promise} resolved promise of email if existing, otherwise null.
 */
export const getExistingEmail = async email => {
	return axiosInstance
		.get(`api/CustomValidation/List/EMAIL_EXISTING`, {
			params: {
				value: email,
			},
		})
		.then(response => {
			return then(response, payload => payload);
		})
		.catch(error => {
			throw error;
		});
};
